var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2112_13195)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56225 16.7344C13.5231 16.7344 16.7339 13.5235 16.7339 9.56273C16.7339 5.60192 13.5231 2.39105 9.56225 2.39105C5.60143 2.39105 2.39056 5.60192 2.39056 9.56273C2.39056 13.5235 5.60143 16.7344 9.56225 16.7344ZM18.3276 9.56273C18.3276 14.4037 14.4032 18.3281 9.56225 18.3281C4.72125 18.3281 0.796854 14.4037 0.796854 9.56273C0.796854 4.72174 4.72125 0.797342 9.56225 0.797342C14.4032 0.797342 18.3276 4.72174 18.3276 9.56273ZM9.56225 13.547C9.12215 13.547 8.76539 13.1902 8.76539 12.7501V9.56273C8.76539 9.12264 9.12215 8.76588 9.56225 8.76588C10.0023 8.76588 10.3591 9.12264 10.3591 9.56273V12.7501C10.3591 13.1902 10.0023 13.547 9.56225 13.547ZM10.3591 6.37532C10.3591 6.81541 10.0023 7.17217 9.56225 7.17217H9.55428C9.11419 7.17217 8.75742 6.81541 8.75742 6.37532C8.75742 5.93523 9.11419 5.57846 9.55428 5.57846H9.56225C10.0023 5.57846 10.3591 5.93523 10.3591 6.37532Z",
    fill: "#017C57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2112_13195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1245,
    height: 19.1245,
    fill: "white",
    transform: "matrix(-1 0 0 -1 19.1245 19.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.eaea0bd8f736399ad2f902e56b75b8ee.svg";
export { ForwardRef as ReactComponent };